'use client';

import { useTranslations } from 'next-intl';
import { SettingsEmptyState } from '@terra/ui-design-system';
import { VStack } from '@terra/ui-styled-system';
import { AiApplicationGeneralSettingsSection } from '../AiApplicationGeneralSettingsSection';
import { TargetApplicationGeneralSection } from './TargetApplicationGeneralSection';
import { TargetScanEffortCard } from './TargetScanEffortCard';

type TargetGeneralPanelProps = {
  hasProjectSelected: boolean;
  isAiApplicationTarget: boolean;
  appTargetId: string | undefined;
  isReadOnly?: boolean;
  onOpenApiDocumentation: () => void;
};

export function TargetGeneralPanel({
  hasProjectSelected,
  isAiApplicationTarget,
  appTargetId,
  isReadOnly,
  onOpenApiDocumentation,
}: TargetGeneralPanelProps) {
  const t = useTranslations('proxy.mainContentArea');
  const applicationId = hasProjectSelected ? appTargetId : undefined;

  if (!applicationId) {
    return (
      <SettingsEmptyState>
        {t('selectApplicationToGetStarted')}
      </SettingsEmptyState>
    );
  }

  return (
    <VStack gap="8" w="full" alignItems="stretch">
      {isAiApplicationTarget ? (
        <AiApplicationGeneralSettingsSection
          applicationId={applicationId}
          isReadOnly={isReadOnly}
        />
      ) : (
        <>
          <TargetApplicationGeneralSection
            applicationId={applicationId}
            isReadOnly={isReadOnly}
            onOpenApiDocumentation={onOpenApiDocumentation}
          />
          <TargetScanEffortCard
            applicationId={applicationId}
            isReadOnly={isReadOnly}
          />
        </>
      )}
    </VStack>
  );
}
